/**
 * Shared styles using MUI theme tokens.
 * These styles use theme palette references and can be spread into sx props.
 */

import { SxProps, Theme } from '@mui/material';

/**
 * Scrollbar styles using theme custom palette colors.
 * Use by spreading into sx prop: sx={{ ...scrollbarStyles, ...otherStyles }}
 */
export const scrollbarStyles: SxProps<Theme> = {
  '&::-webkit-scrollbar': {
    width: '4px',
  },
  '&::-webkit-scrollbar-track': {
    bgcolor: 'custom.scrollbarTrack',
    borderRadius: '2px',
  },
  '&::-webkit-scrollbar-thumb': {
    bgcolor: 'custom.scrollbarThumb',
    borderRadius: '2px',
    '&:hover': {
      bgcolor: 'custom.scrollbarThumbHover',
    },
  },
  // Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: (theme: Theme) =>
    `${theme.palette.custom.scrollbarThumb} ${theme.palette.custom.scrollbarTrack}`,
};

/**
 * Wide scrollbar variant (6px instead of 4px).
 * Use for larger content areas like the rich text editor.
 */
export const scrollbarStylesWide: SxProps<Theme> = {
  '&::-webkit-scrollbar': {
    width: '6px',
  },
  '&::-webkit-scrollbar-track': {
    bgcolor: 'custom.scrollbarTrack',
    borderRadius: '3px',
  },
  '&::-webkit-scrollbar-thumb': {
    bgcolor: 'custom.scrollbarThumb',
    borderRadius: '3px',
    '&:hover': {
      bgcolor: 'custom.scrollbarThumbHover',
    },
  },
  // Firefox
  scrollbarWidth: 'thin',
  scrollbarColor: (theme: Theme) =>
    `${theme.palette.custom.scrollbarThumb} ${theme.palette.custom.scrollbarTrack}`,
};
